function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Pages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-30.000000, -171.000000)",
  fill: "#257FE8",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Navigation"
}, /*#__PURE__*/React.createElement("g", {
  id: "Coffee-pack,-c",
  transform: "translate(30.000000, 171.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "20 20 17.5 3.33325 16.66675 3.33325 14.16675 20"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 2.5,
  y: 0,
  width: 15,
  height: 1.66675
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5,3.33325 L0,20 L12.48125,20 L14.98125,3.33325 L2.5,3.33325 Z M6.73175,11.89775 C6.163,13.269 5.953,14.786 6.142,16.30125 C4.743,15.5755 3.75,13.76625 3.75,11.64475 C3.75,9.02825 5.258,6.88475 7.17775,6.66675 C7.55775,8.357 7.44375,10.1765 6.73175,11.89775 Z M7.87275,16.6195 C7.596,15.259 7.72875,13.847 8.2715,12.535 C8.80125,11.255 9.06675,9.90975 9.06675,8.567 C9.06675,8.05175 9.0155,7.5385 8.93725,7.02725 C10.2955,7.779 11.25,9.563 11.25,11.64475 C11.25,14.23825 9.76875,16.37025 7.87275,16.6195 Z",
  id: "Shape"
})))));

var SvgBrews = function SvgBrews(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brews.088944ae.svg";
export { ForwardRef as ReactComponent };